enum TabSelectLabel {
  Placement = 'Placement',
  Location = 'Location',
}

export default TabSelectLabel;
